module.exports = __webpack_public_path__ + "img/ydzrbf3.8f891094.png";